import {Pipe, PipeTransform} from "@angular/core";

@Pipe({name: 'transformLog'})
export class LogTransformer implements PipeTransform {
    transform(log: string, keys: any[]): string {
        for (let key in keys) {
            log = log.replace('%' + key + '%', keys[key]);
        }
        return log;
    }
}
